/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Modal, Paper, Slide } from '@material-ui/core'

import { getDirection, getTranslate } from '../../localization'
import { FullJobStatueAndDetails } from '../../types/BulkAccessManagement'
import { JobStatusForRateplan } from '../../types/rateplan'
import { JobDetailsModalTable } from './JobDetailsModalTable'
import useStyles from './styles/jobDetails.styles'

interface ChannelAPIKeyModalProps {
  isOpen: boolean
  onClose: () => void
  userRows?: FullJobStatueAndDetails[]
  ratePlanRows?: JobStatusForRateplan[]
}

const JobDetailsModal: React.FC<ChannelAPIKeyModalProps> = ({
  isOpen,
  onClose,
  userRows,
  ratePlanRows
}) => {
  const classes = useStyles()

  return (
    <Modal
      dir={getDirection()}
      open={isOpen}
      onClose={onClose}
      className={classes.modal}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <JobDetailsModalTable
            userRows={userRows || []}
            ratePlanRows={ratePlanRows || []}
          />
          <div className={classes.buttonsContainer}>
            <Button
              onClick={() => onClose()}
              variant="contained"
              color="primary"
              className={classes.deleteButton}>
              {getTranslate('Close')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default JobDetailsModal
